/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";

export default function TaxValue06() {
  const { formId, formField } = form;
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box display="flex" flexDirection="column" pb={10} gap={3}>
        <Box textAlign="center">
          <Typography variant="h4" textTransform="uppercase">
            Danh sách dự án đầu tư
          </Typography>
        </Box>
        <Formik initialValues={initialValues} validationSchema={validation} onSubmit={handleSubmit}>
          {({ values, errors, touched, isSubmitting, setFieldValue }) => (
            <Form id={formId} autoComplete="off">
              {/* <Fields
                formData={{
                  values,
                  touched,
                  formField,
                  errors,
                }}
              /> */}
              <TaxPersonalTable
                formData={{
                  values,
                  touched,
                  formField,
                  errors,
                }}
                setFieldValue={setFieldValue}
              />
              <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">
                  {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                </SoftButton>
              </SoftBox>
            </Form>
          )}
        </Formik>
      </Box>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    firstTime,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    contractNumber,
    contractDay,
    addressWard,
    addressDistrict,
    addressCity,
    activeAddress,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={contractNumber.name}
            label={contractNumber.label}
            value={values.contractNumber}
            error={errors.contractNumber && touched.contractNumber}
            success={values.contractNumber?.toString().length > 0 && !errors.contractNumber}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={contractDay.name}
            label={contractDay.label}
            error={errors.contractDay && touched.contractDay}
            success={values.contractDay?.toString().length > 0 && !errors.contractDay}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={activeAddress.name}
            label={activeAddress.label}
            value={values.activeAddress}
            error={errors.activeAddress && touched.activeAddress}
            success={values.activeAddress?.toString().length > 0 && !errors.activeAddress}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={addressCity.name}
            label={addressCity.label}
            value={values.addressCity}
            error={errors.addressCity && touched.addressCity}
            success={values.addressCity?.toString().length > 0 && !errors.addressCity}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={addressDistrict.name}
            label={addressDistrict.label}
            value={values.addressDistrict}
            error={errors.addressDistrict && touched.addressDistrict}
            success={values.addressDistrict?.toString().length > 0 && !errors.addressDistrict}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={addressWard.name}
            label={addressWard.label}
            value={values.addressWard}
            error={errors.addressWard && touched.addressWard}
            success={values.addressWard?.toString().length > 0 && !errors.addressWard}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
